<template>
  <div
    class="upload-container"
    :class="{ 'drag-over': is_drag_over }"
    :style="`min-height: ${data.min_height || '80px'}`"
    @click="$refs.inputFile.click()"
    @dragover.prevent="handleDragOver"
    @dragleave="handleDragLeave"
    @drop.prevent="handleDrop"
  >
    <div class="upload-content h-100" v-if="!file">
      <div class="d-flex align-items-center">
        <component :is="data.icon.type" :icon="data.icon.name" class="mr-05" />
        <strong>{{ data.title }}</strong>
      </div>
      <p class="m-0">{{ data.subtitle }}</p>
    </div>

    <div v-else class="d-flex justify-content-between w-100">
      <div class="d-flex align-items-center w-80">
        <b-avatar :text="getExtension()" square class="avatar-preview-sample-upload-invoice" />
        <span class="text-overflow">{{ file.name }}</span>
      </div>
      <b-button variant="flat-secondary" @click.stop="file = null; $emit('file_loaded', null);">
        <feather-icon icon="TrashIcon" size="20" />
      </b-button>
    </div>

    <input
      type="file"
      :accept="data.extensions_allowed"
      ref="inputFile"
      @change="handleFileUpload"
      class="input-file-hidden"
    />
  </div>
</template>

<script>
import { BButton, BAvatar } from 'bootstrap-vue';

export default {
  name: 'inputDragAndDropFile',
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  components: {
    BButton,
    BAvatar,
  },
  data() {
    return {
      file: null,
      is_drag_over: false,
    };
  },
  methods: {
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.$emit('file_loaded', this.file);
      this.$refs.inputFile.value = null;
    },
    getExtension() {
      try {
        const extension = this.file.type.split('/')[1];
        return this.data.extensions_allowed.includes(extension) ? extension : 'file';
      } catch (error) {
        return 'file';
      }
    },
    handleDragOver() {
      this.is_drag_over = true;
    },
    handleDragLeave() {
      this.is_drag_over = false;
    },
    handleDrop(event) {
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.file = files[0];
      }
      this.is_drag_over = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-container {
  border: 1px dashed #3483fa;
  border-radius: 0.4rem;
  padding: 1.2rem;
  cursor: pointer;
  transition: border 0.2s, outline 0.2s;
  height: 100%;
  .w-80 {
    width: 80%;
  }

  &:hover {
    outline: 2px solid #3483fa;
  }

  &.drag-over {
    background-color: #e0f0ff;
    border: 2px dashed #3483fa;
  }
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  strong {
    display: block;
  }

  p {
    font-size: 13px;
    color: #6d6b77;
  }
}

.input-file-hidden {
  display: none;
}
.text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.avatar-preview-sample-upload-invoice {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 1em !important;
  margin: 0 1em 0 0;
  background-color: #e5e5e6;
  color: #444;
}
</style>
